import React, { FC } from 'react'

import { MacronutrientProgressBars } from 'Components/MacronutrientCard/MacronutrientProgressBars'
import { Nutritions } from 'Models'

export type MacronutrientCardProps = {
  isLoading: boolean
  acceptedNutritions?: Nutritions
  goalNutritions?: Nutritions
}

export const MacronutrientCard: FC<MacronutrientCardProps> = ({ isLoading, acceptedNutritions, goalNutritions }) => {
  return (
    <>
      <section className={`standardcard mb-2 py-1`}>
        <div className="standardcard-content">
          {acceptedNutritions && goalNutritions && (
            <MacronutrientProgressBars
              acceptedNutritions={acceptedNutritions}
              goalNutritions={goalNutritions}
              isLoading={isLoading}
            />
          )}
        </div>
      </section>
    </>
  )
}
